import { useEffect, useState } from 'react';
import {
  isEmulatorWaitingToStart,
  openEmulatorMenuOrControls,
  startEmulatorGame,
} from '../lib/emulatorMenu.js';

export function PlayScreen({ loading, loadingText, needsManualStart, onBack }) {
  const [awaitingStart, setAwaitingStart] = useState(false);

  useEffect(() => {
    if (!needsManualStart || loading) {
      setAwaitingStart(false);
      return undefined;
    }
    const tick = () => setAwaitingStart(isEmulatorWaitingToStart());
    tick();
    const id = window.setInterval(tick, 400);
    return () => window.clearInterval(id);
  }, [needsManualStart, loading]);

  const handleMenu = () => {
    openEmulatorMenuOrControls();
  };

  const handleStart = () => {
    startEmulatorGame();
    setAwaitingStart(isEmulatorWaitingToStart());
  };

  return (
    <div className="arcade-floor arcade-floor--play">
      <main className="play-stage">
        <div className="play-fab-stack">
          <button
            type="button"
            className="play-back-fab"
            onClick={onBack}
            aria-label="Voltar à biblioteca"
            title="Biblioteca"
          >
            ←
          </button>
          <button
            type="button"
            className="play-menu-fab"
            onClick={handleMenu}
            disabled={loading}
            aria-label="Menu do emulador"
            title="Menu — controlos, pausa, guardar, opções"
          >
            Menu
          </button>
        </div>

        <div className="play-crt-wrap">
          <div className="crt-bezel crt-bezel--play">
            <div className="crt-inner crt-inner--play">
              <div id="game" aria-label="Área do emulador" />
              <div className="crt-scanlines" aria-hidden="true" />
              <div className="crt-vignette" aria-hidden="true" />
              <div
                className={`crt-loading${loading ? ' is-active' : ''}`}
                role="status"
                aria-live="polite"
              >
                <div className="crt-loading__spinner" aria-hidden="true" />
                <p className="crt-loading__text">{loadingText}</p>
              </div>
              {awaitingStart && (
                <div className="play-start-overlay">
                  <button
                    type="button"
                    className="play-start-btn"
                    onClick={handleStart}
                    aria-label="Iniciar jogo"
                  >
                    ▶ Iniciar jogo
                  </button>
                  <p className="play-start-hint">Nintendo DS — toca para arrancar (áudio do browser)</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
